import { Notifier } from '@airbrake/browser';

const buildAirbrakeNotifier = (projectId, projectKey, environment) => {
  if (!projectId || !projectKey || !environment) {
    return null;
  }

  return new Notifier({
    projectId: projectId,
    projectKey: projectKey,
    environment: environment
  });
};

export default buildAirbrakeNotifier;
